export var RestoreJobType;
(function (RestoreJobType) {
    RestoreJobType["RestoreJobTypeUnspecified"] = "RESTORE_JOB_TYPE_UNSPECIFIED";
    RestoreJobType["AwsS3ObjectRestore"] = "AWS_S3_OBJECT_RESTORE";
    RestoreJobType["AwsS3BucketRestore"] = "AWS_S3_BUCKET_RESTORE";
    RestoreJobType["AwsEc2FileRestore"] = "AWS_EC2_FILE_RESTORE";
    RestoreJobType["AwsEc2InstanceRestore"] = "AWS_EC2_INSTANCE_RESTORE";
    RestoreJobType["AwsEc2AmiConvert"] = "AWS_EC2_AMI_CONVERT";
    RestoreJobType["AwsEc2EbsVolumeRestore"] = "AWS_EC2_EBS_VOLUME_RESTORE";
    RestoreJobType["AwsEc2EbsSnapshotConvert"] = "AWS_EC2_EBS_SNAPSHOT_CONVERT";
    RestoreJobType["AwsEc2RecordRestore"] = "AWS_EC2_RECORD_RESTORE";
    RestoreJobType["AwsEbsVolumeRestore"] = "AWS_EBS_VOLUME_RESTORE";
    RestoreJobType["AwsEbsSnapshotConvert"] = "AWS_EBS_SNAPSHOT_CONVERT";
    RestoreJobType["AwsRdsInstanceRestore"] = "AWS_RDS_INSTANCE_RESTORE";
    RestoreJobType["AwsRdsRecordRestore"] = "AWS_RDS_RECORD_RESTORE";
    RestoreJobType["AwsEksNamespaceRestore"] = "AWS_EKS_NAMESPACE_RESTORE";
    RestoreJobType["AwsEksNamespaceRecordRestore"] = "AWS_EKS_NAMESPACE_RECORD_RESTORE";
    RestoreJobType["AwsEksFileRestore"] = "AWS_EKS_FILE_RESTORE";
    RestoreJobType["AwsDynamoDbTableRestore"] = "AWS_DYNAMO_DB_TABLE_RESTORE";
    RestoreJobType["AwsDynamoDbTableToExistingTableRestore"] = "AWS_DYNAMO_DB_TABLE_TO_EXISTING_TABLE_RESTORE";
    RestoreJobType["AwsDynamoDbRestoreToS3"] = "AWS_DYNAMO_DB_RESTORE_TO_S3";
    RestoreJobType["AwsDynamoDbRecordRestore"] = "AWS_DYNAMO_DB_RECORD_RESTORE";
    RestoreJobType["AzureStorageAccountRestore"] = "AZURE_STORAGE_ACCOUNT_RESTORE";
    RestoreJobType["AzureStorageAccountBlobRestore"] = "AZURE_STORAGE_ACCOUNT_BLOB_RESTORE";
    RestoreJobType["AzureVmFileRestore"] = "AZURE_VM_FILE_RESTORE";
    RestoreJobType["AzureVmDiskRestore"] = "AZURE_VM_DISK_RESTORE";
    RestoreJobType["AzureVmInstanceRestore"] = "AZURE_VM_INSTANCE_RESTORE";
    RestoreJobType["AzureVmRecordRestore"] = "AZURE_VM_RECORD_RESTORE";
    RestoreJobType["AzureSqlDatabaseRecordRestore"] = "AZURE_SQL_DATABASE_RECORD_RESTORE";
    RestoreJobType["AzureSqlDatabaseRestore"] = "AZURE_SQL_DATABASE_RESTORE";
    RestoreJobType["AzureSqlVmInstanceRestore"] = "AZURE_SQL_VM_INSTANCE_RESTORE";
    RestoreJobType["AzureSqlVmRecordRestore"] = "AZURE_SQL_VM_RECORD_RESTORE";
    RestoreJobType["AzurePostgresqlRecordRestore"] = "AZURE_POSTGRESQL_RECORD_RESTORE";
    RestoreJobType["AzureSapHanaVmInstanceRestore"] = "AZURE_SAP_HANA_VM_INSTANCE_RESTORE";
    RestoreJobType["GcpCloudStorageBucketRestore"] = "GCP_CLOUD_STORAGE_BUCKET_RESTORE";
    RestoreJobType["GcpCloudStorageObjectRestore"] = "GCP_CLOUD_STORAGE_OBJECT_RESTORE";
    RestoreJobType["GcpComputeEngineFileRestore"] = "GCP_COMPUTE_ENGINE_FILE_RESTORE";
    RestoreJobType["GcpComputeEngineDiskRestore"] = "GCP_COMPUTE_ENGINE_DISK_RESTORE";
    RestoreJobType["GcpComputeEngineInstanceRestore"] = "GCP_COMPUTE_ENGINE_INSTANCE_RESTORE";
    RestoreJobType["GcpComputeEngineRecordRestore"] = "GCP_COMPUTE_ENGINE_RECORD_RESTORE";
    RestoreJobType["GcpCloudSqlDatabaseRestore"] = "GCP_CLOUD_SQL_DATABASE_RESTORE";
    RestoreJobType["GcpCloudSqlRecordRestore"] = "GCP_CLOUD_SQL_RECORD_RESTORE";
    RestoreJobType["GcpBigqueryDatasetRestore"] = "GCP_BIGQUERY_DATASET_RESTORE";
    RestoreJobType["GcpBigqueryRecordRestore"] = "GCP_BIGQUERY_RECORD_RESTORE";
    RestoreJobType["GcpBigqueryNativeRestoreDataset"] = "GCP_BIGQUERY_NATIVE_RESTORE_DATASET";
    RestoreJobType["GcpBigqueryNativeRestoreTable"] = "GCP_BIGQUERY_NATIVE_RESTORE_TABLE";
    RestoreJobType["RdsNativePitrRestore"] = "RDS_NATIVE_PITR_RESTORE";
    RestoreJobType["AwsFsxRestore"] = "AWS_FSX_RESTORE";
    RestoreJobType["AwsRedshiftRestore"] = "AWS_REDSHIFT_RESTORE";
    RestoreJobType["AwsDocumentdbRestore"] = "AWS_DOCUMENTDB_RESTORE";
    RestoreJobType["AwsNeptuneRestore"] = "AWS_NEPTUNE_RESTORE";
    RestoreJobType["GcpSapHanaVmInstanceRestore"] = "GCP_SAP_HANA_VM_INSTANCE_RESTORE";
    RestoreJobType["AwsKeyspacesTableRestore"] = "AWS_KEYSPACES_TABLE_RESTORE";
    RestoreJobType["AwsKeyspacesRecordRestore"] = "AWS_KEYSPACES_RECORD_RESTORE";
    RestoreJobType["AtlasClusterRestore"] = "ATLAS_CLUSTER_RESTORE";
    RestoreJobType["AtlasClusterRecordRestore"] = "ATLAS_CLUSTER_RECORD_RESTORE";
    RestoreJobType["Microsoft365Restore"] = "MICROSOFT_365_RESTORE";
    RestoreJobType["ExportAccessDeniedItems"] = "EXPORT_ACCESS_DENIED_ITEMS";
})(RestoreJobType || (RestoreJobType = {}));
